import CardRail from '../CardRail';
import ThemeCard from '../ThemeCard';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { HotelsNearPOIsInLocationCardsProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/HotelsNearPOIsInLocationCardsProps';

const HotelsNearPOIsInLocationCards = ({
  cards,
  subtitle,
  title,
}: HotelsNearPOIsInLocationCardsProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  if (cards.length <= 0) {
    return null;
  }

  return (
    <div
      className="HotelsNearPOIsInLocationCards"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <CardRail title={title} subtitle={subtitle}>
        {(layout) =>
          cards.map((card, index) => (
            <ThemeCard
              key={card.title}
              {...card}
              index={`${layout}_${index}`}
            />
          ))
        }
      </CardRail>
    </div>
  );
};

export default HotelsNearPOIsInLocationCards;
